"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.promisify = promisify;
exports.promiseAllSettled = promiseAllSettled;

var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _setTimeout2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set-timeout"));

var defaultTimeout = 3000; // promisify 功能并且有timeout, 传Infinity

function promisify(executor) {
  var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultTimeout;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var p1 = new _promise["default"](function (resolve, reject) {
      var _context;

      executor.apply(void 0, (0, _concat["default"])(_context = [resolve, reject]).call(_context, args));
    }); // 设置Infinity的timeout则直接返回promise

    if (!isFinite(timeout)) {
      return p1;
    }

    var p2 = new _promise["default"](function (resolve, reject) {
      (0, _setTimeout2["default"])(function () {
        reject(new Error("call timeout ".concat(timeout)));
      }, timeout);
    });
    return _promise["default"].race([p1, p2]);
  };
}

function promiseAllSettled(promises) {
  var waitUntil = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3000;
  defaultTimeout = waitUntil;
  var results = [];
  var promiseCount = 0;
  var promisesLength = promises.length;
  return new _promise["default"](function (resolve) {
    var handler = function handler(res, i) {
      promiseCount += 1;
      results[i] = res;

      if (promiseCount === promisesLength) {
        return resolve(results);
      }
    };

    var _loop = function _loop(i) {
      var p = promises[i];
      p.then(function (res) {
        handler(res, i);
      }, function () {
        handler('', i);
      });
    };

    for (var i = 0; i < promisesLength; i++) {
      _loop(i);
    }
  });
}